import React from 'react';
import './Loader.scss';
import loaderImg from '../assets/images/logo/3.png'; // replace with your image path

const Loader = () => {
  return (
    <div className="Loader">
      <img src={loaderImg} alt="Loading..." className="loader-image" />
    </div>
  );
};

export default Loader;
